import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackLegacyPageView, trackNewPageView } from "@/lib/metaPixel";

// Module scope so remounts/rerenders never re-send for the same pathname.
let lastPath: string | null = null;

/** Fires one page view per genuine pathname change (initial, links, back/forward). Hash/query-only changes are ignored. */
export default function MetaPixelRouteTracker({ skipPaths = [] }: { skipPaths?: string[] }) {
  const { pathname } = useLocation();
  useEffect(() => {
    if (skipPaths.includes(pathname)) return; // redirect stubs: the final page is tracked instead
    if (pathname === lastPath) return;
    const initial = lastPath === null;
    lastPath = pathname;
    if (!initial) trackLegacyPageView(); // initial legacy PageView is sent by index.html
    trackNewPageView();
  }, [pathname, skipPaths]);
  return null;
}
